var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataRecoverable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10790_64458)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_10790_64458)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7516 15.1949C13.7516 13.4872 15.1809 12.1416 16.8953 12.1416C18.6098 12.1416 20.0391 13.4872 20.0391 15.1949C20.0391 16.9025 18.6098 18.2481 16.8953 18.2481C15.1808 18.2481 13.7516 16.9025 13.7516 15.1949ZM16.8953 13.3916C15.8277 13.3916 15.0016 14.2203 15.0016 15.1949C15.0016 16.1694 15.8277 16.9981 16.8953 16.9981C17.9629 16.9981 18.7891 16.1694 18.7891 15.1949C18.7891 14.2203 17.9629 13.3916 16.8953 13.3916ZM13.3693 21.1628C13.1363 21.1628 12.9868 21.3392 12.9868 21.5091V26.8513C12.9868 28.8987 14.7151 30.5971 16.8955 30.5971C17.643 30.5971 18.3388 30.3966 18.9301 30.0503C19.2279 29.8759 19.6108 29.9759 19.7852 30.2738C19.9597 30.5717 19.8596 30.9545 19.5618 31.129C18.7823 31.5854 17.869 31.8471 16.8955 31.8471C14.0682 31.8471 11.7368 29.6318 11.7368 26.8513V21.5091C11.7368 20.6061 12.4894 19.9128 13.3693 19.9128H21.4292C21.7744 19.9128 22.0542 20.1926 22.0542 20.5378C22.0542 20.883 21.7744 21.1628 21.4292 21.1628H13.3693ZM31.1177 23.5755C31.3618 23.3314 31.3618 22.9357 31.1177 22.6916C30.8736 22.4475 30.4779 22.4475 30.2338 22.6916L25.8359 27.0895L24.3317 25.5853C24.0876 25.3412 23.6919 25.3412 23.4478 25.5853C23.2038 25.8294 23.2038 26.2251 23.4478 26.4692L25.394 28.4153C25.6381 28.6594 26.0338 28.6594 26.2779 28.4153L31.1177 23.5755ZM25.7138 20.0935C25.9579 19.8494 26.3536 19.8494 26.5977 20.0935L27.5119 21.0077C27.756 21.2518 27.756 21.6475 27.5119 21.8916L26.5969 22.8066C26.3529 23.0507 25.9571 23.0507 25.7131 22.8066C25.5421 22.6356 25.4909 22.3903 25.5594 22.1747C23.4269 22.3962 21.7642 24.199 21.7642 26.3901C21.7642 28.7309 23.6617 30.6284 26.0024 30.6284C28.3432 30.6284 30.2407 28.7309 30.2407 26.3901C30.2407 26.045 30.5205 25.7651 30.8657 25.7651C31.2109 25.7651 31.4907 26.045 31.4907 26.3901C31.4907 29.4212 29.0335 31.8784 26.0024 31.8784C22.9713 31.8784 20.5142 29.4212 20.5142 26.3901C20.5142 23.475 22.787 21.0907 25.6573 20.9125C25.4715 20.6676 25.4903 20.317 25.7138 20.0935Z",
    fill: "#1B202C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10790_64458",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10790_64458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataRecoverable);
export default __webpack_public_path__ + "static/media/data-recoverable.1b50b23ed35672e28ffc8d70346573b0.svg";
export { ForwardRef as ReactComponent };